import React, {FC} from 'react';
import {
    Wrapper,
    ContentHeader,
    GamesWrapper,
    GameCard,
    GameCardWrapper,
    SocialWrapper,
    SocialLink,
    GameCardText,
    SocialLinkAlt,
    SocialWrapperAlt,
    GameCardMock,
    GameCardMockText,
    GameCardDescriptionWrapper,
    GameCardDescription
} from "./styles";
import {ReactComponent as VkIcon} from '../../assets/icons/icons8-vk.svg';
import {ReactComponent as YaIcon} from '../../assets/icons/icons8-yandex.svg';
import {ReactComponent as OkIcon} from '../../assets/icons/icons8-ok.svg';
import Cover from "../../assets/images/cover1.jpg";
import Cover2 from "../../assets/images/cover2.jpg";

const Projects: FC = () => {
    return (
        <Wrapper>
            <ContentHeader id="games">НАШИ ИГРЫ</ContentHeader>

            <GamesWrapper>
                <GameCardWrapper>
                    <GameCard url={Cover}>
                        <SocialWrapper>
                            <SocialLink href="https://vk.com/app51746892" target="_blank">
                                <VkIcon/>
                            </SocialLink>
                            <SocialLink href="https://yandex.ru/games/app/254839?lang=ru" target="_blank">
                                <YaIcon/>
                            </SocialLink>
                            <SocialLink href="https://ok.ru/game/mahjongclassic" target="_blank">
                                <OkIcon/>
                            </SocialLink>
                        </SocialWrapper>
                    </GameCard>
                    <GameCardDescriptionWrapper>
                        <GameCardText>
                            Маджонг Классика
                        </GameCardText>
                        <GameCardDescription>
                            Классический пасьянс маджонг. Наша команда смогла реализовать уникальный алгоритм генерации уровней -
                            рандомная выкладка с гарантированным решением уровня. Эта уникальная разработка позволяет игрокам неограниченное число
                            раз проходить любимые поля с интересом.
                            В игру играет уже более 300 000 игроков на платформах Яндекс.Игры, В Контакте и Одноклассники.
                        </GameCardDescription>
                        <SocialWrapperAlt>
                            <SocialLinkAlt href="https://vk.com/app51746892" target="_blank">
                                <VkIcon/>
                            </SocialLinkAlt>
                            <SocialLinkAlt href="https://yandex.ru/games/app/254839?lang=ru" target="_blank">
                                <YaIcon/>
                            </SocialLinkAlt>
                            <SocialLinkAlt href="https://ok.ru/game/mahjongclassic" target="_blank">
                                <OkIcon/>
                            </SocialLinkAlt>
                        </SocialWrapperAlt>
                    </GameCardDescriptionWrapper>
                </GameCardWrapper>

                <GameCardWrapper>
                    <GameCard url={Cover2}>
                        <SocialWrapper>
                            <SocialLink href="https://vk.com/app52777143" target="_blank">
                                <VkIcon/>
                            </SocialLink>
                            <SocialLink href="https://yandex.ru/games/app/389376?lang=ru" target="_blank">
                                <YaIcon/>
                            </SocialLink>
                            <SocialLink href="https://ok.ru/game/101pharaoh" target="_blank">
                                <OkIcon/>
                            </SocialLink>
                        </SocialWrapper>
                    </GameCard>
                    <GameCardDescriptionWrapper>
                        <GameCardText>
                            101 Фараон Онлайн
                        </GameCardText>
                        <GameCardDescription>
                            101 Фараон Онлайн - азартная карточная игра с красивой графикой. Играйте с реальными людьми и выигрывайте фишки, открывайте новые аватары, карты и столы. Правила похожи на популярные игры 101 и дворовый Штос. Реальный онлайн, игра с живыми людьми!
                            Клади на стол карты такой же масти или значения. Скинь все карты первым и набери меньшее количество очков.
                        </GameCardDescription>
                        <SocialWrapperAlt>
                            <SocialLinkAlt href="https://vk.com/app52777143" target="_blank">
                                <VkIcon/>
                            </SocialLinkAlt>
                            <SocialLinkAlt href="https://yandex.ru/games/app/389376?lang=ru" target="_blank">
                                <YaIcon/>
                            </SocialLinkAlt>
                            <SocialLinkAlt href="https://ok.ru/game/101pharaoh" target="_blank">
                                <OkIcon/>
                            </SocialLinkAlt>
                        </SocialWrapperAlt>
                    </GameCardDescriptionWrapper>
                </GameCardWrapper>
            </GamesWrapper>
        </Wrapper>
    );
}

export default Projects;